export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEFQWRkLUhhCyEiAb1PAADATAAAwFILAb1RCQK9UwIEvVYAAMBaAADAUwAAwFgAAMBVABG9W0EKJCG9bgEAAQABAAEAGQAfAAEAAQAGAGEBJHUBwEhBCiUhvXgBAAEAAQABABkAHwABAAEABgBhByV1Ab4CgaNiAL4HAAC+BAAAwQkAAL4FAADBCgABwRNRC3dgvgmGEIYPBoYYhhcHhhIEhhOGCGEHd2sBwR0AAMEmAADBJQAAwSEAAMEkBADBBIt8AMEN", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/Add-V.bcmap
// module id = 585
// module chunks = 502